import { AttendeeFragment, PublicEWebinarFragment } from '$/GraphQL/schema/types';
import { injectAttendeeFieldsBasic } from '$/shared/frontend/utils/replacePlaceholders';
import type { ActionPropertiesHash } from '$/shared/typesProxy';
import { ConversationWithMessage } from '../hooks/useGetConversation';

export const propertyFilledText = (
  text: string | undefined | null,
  locale: Locale | undefined,
  ewebinar?: PublicEWebinarFragment,
  properties?: ActionPropertiesHash,
  attendee?: AttendeeFragment | ConversationWithMessage['attendee']
): string => {
  if (!text) return '';
  if (!attendee || !properties) return text;

  return injectAttendeeFieldsBasic(text, locale, attendee, ewebinar, properties);
};
